// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"351":"34877cfe","499":"6351a5df","959":"34877cfe"}[chunkId] + ".chunk.css";
};